import { Link } from 'react-router-dom';
import type { Dossier } from '@/mocks/dossiers';
import { formatHeat } from '@/utils/dossiers';
import DimensionTag from '@/components/feature/DimensionTag';

interface DossierCardProps {
  dossier: Dossier;
  order?: number;
}

export default function DossierCard({ dossier, order }: DossierCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300">
      <Link to={`/dossier/${dossier.id}`} className="block" aria-label={dossier.title}>
        <div className="relative h-48 w-full overflow-hidden md:h-52">
          <img
            src={dossier.cover}
            alt={dossier.title}
            title={`${dossier.title} - 爆料看点拆解档案`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          {typeof order === 'number' && (
            <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-background-50/90 font-heading text-sm font-bold text-foreground-900">
              {String(order + 1).padStart(2, '0')}
            </span>
          )}
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <DimensionTag id={dossier.dimension} />
        <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950">
          <Link to={`/dossier/${dossier.id}`} className="transition-colors hover:text-primary-600">
            {dossier.title}
          </Link>
        </h3>
        <p className="mb-5 mt-3 line-clamp-2 font-body text-sm leading-relaxed text-foreground-600">
          {dossier.summary}
        </p>

        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-4">
          <span className="font-label text-xs text-foreground-500">
            {dossier.author} · {dossier.readTime}
          </span>
          <span className="inline-flex items-center gap-1 font-label text-xs text-primary-600">
            <i className="ri-fire-line" />
            {formatHeat(dossier.heat)}
          </span>
        </div>
      </div>
    </article>
  );
}